/**
 * GoBox Video Carousel - 3D JavaScript
 * Handles 3D positioning, navigation, and video playback
 */

(function() {
  'use strict';

  const state = {
    carousels: {}
  };

  function init() {
    setupVideoCarousels();
  }

  /**
   * Setup all video carousels on the page
   */
  function setupVideoCarousels() {
    const carousels = document.querySelectorAll('[id^="video-carousel-"]');
    
    carousels.forEach((carousel) => {
      const sectionId = carousel.id.replace('video-carousel-', '');
      const items = carousel.querySelectorAll('.video-carousel-item');
      const dots = carousel.parentElement.querySelectorAll('.carousel-dot');
      const leftBtn = carousel.parentElement.querySelector('.carousel-nav-left');
      const rightBtn = carousel.parentElement.querySelector('.carousel-nav-right');
      
      if (items.length === 0) return;

      // Initialize state for this carousel
      state.carousels[sectionId] = {
        currentIndex: 0,
        totalVideos: items.length,
        playingVideos: {}
      };

      // Update carousel positioning
      function updateCarousel() {
        const { currentIndex, totalVideos } = state.carousels[sectionId];
        const angleStep = (2 * Math.PI) / totalVideos;
        const radius = 450;

        items.forEach((item, index) => {
          const baseAngle = index * angleStep;
          const rotationOffset = -currentIndex * angleStep;
          const currentAngle = baseAngle + rotationOffset;

          const translateX = Math.sin(currentAngle) * radius;
          const translateZ = Math.cos(currentAngle) * radius - radius;
          const baseRotateY = (currentAngle * 180) / Math.PI;
          const sideOffset = Math.sin(currentAngle);
          const rotateY = baseRotateY + (sideOffset * 15);

          const zPosition = Math.cos(currentAngle) * radius;
          const scale = Math.max(0.75, 1 - (Math.abs(zPosition) / 800));
          const opacity = Math.max(0.65, 1 - (Math.abs(zPosition) / 1000));
          const zIndex = Math.round(zPosition + radius);

          item.style.transform = `translateX(${translateX}px) translateZ(${translateZ}px) rotateY(${rotateY}deg) scale(${scale})`;
          item.style.opacity = opacity;
          item.style.zIndex = zIndex;
        });

        // Update dots
        dots.forEach((dot, index) => {
          if (index === currentIndex) {
            dot.classList.add('active');
            dot.style.width = '32px';
            dot.style.background = 'rgba(220, 38, 38, 0.8)';
          } else {
            dot.classList.remove('active');
            dot.style.width = '8px';
            dot.style.background = 'rgba(255, 255, 255, 0.2)';
          }
        });

        // Update nav buttons
        if (leftBtn) {
          leftBtn.disabled = currentIndex === 0;
          leftBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
        }
        if (rightBtn) {
          rightBtn.disabled = currentIndex === totalVideos - 1;
          rightBtn.style.opacity = currentIndex === totalVideos - 1 ? '0.5' : '1';
        }
      }

      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          state.carousels[sectionId].currentIndex = index;
          updateCarousel();
        });
      });

      // Arrow navigation
      if (leftBtn) {
        leftBtn.addEventListener('click', () => {
          if (state.carousels[sectionId].currentIndex > 0) {
            state.carousels[sectionId].currentIndex--;
            updateCarousel();
          }
        });
      }

      if (rightBtn) {
        rightBtn.addEventListener('click', () => {
          if (state.carousels[sectionId].currentIndex < state.carousels[sectionId].totalVideos - 1) {
            state.carousels[sectionId].currentIndex++;
            updateCarousel();
          }
        });
      }

      // Video playback controls
      setupVideoControls(carousel, sectionId);

      // Initial update
      updateCarousel();
    });
  }

  /**
   * Setup video play/pause controls
   */
  function setupVideoControls(carousel, sectionId) {
    const playButtons = carousel.querySelectorAll('.video-play-button');
    
    playButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const videoIndex = parseInt(button.dataset.videoIndex || '0');
        const video = carousel.querySelector(`.customer-video[data-index="${videoIndex}"]`);
        
        if (video && video.tagName === 'VIDEO') {
          video.play();
          video.setAttribute('data-playing', 'true');
          state.carousels[sectionId].playingVideos[videoIndex] = true;
        }
      });
    });

    // Handle video play/pause events
    const videos = carousel.querySelectorAll('.customer-video');
    videos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        video.addEventListener('play', () => {
          const index = parseInt(video.dataset.index || '0');
          video.setAttribute('data-playing', 'true');
          state.carousels[sectionId].playingVideos[index] = true;
        });

        video.addEventListener('pause', () => {
          const index = parseInt(video.dataset.index || '0');
          video.removeAttribute('data-playing');
          state.carousels[sectionId].playingVideos[index] = false;
        });

        video.addEventListener('ended', () => {
          const index = parseInt(video.dataset.index || '0');
          video.removeAttribute('data-playing');
          state.carousels[sectionId].playingVideos[index] = false;
        });

        // Click video to pause
        video.addEventListener('click', (e) => {
          if (video.hasAttribute('data-playing')) {
            video.pause();
          }
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
